// extracted by mini-css-extract-plugin
module.exports = {"root":"page.core_root__2epzQ","page":"page.core_page__276FD"};